import { EventActionType } from './event-action-type';
import { castArray } from 'lodash';

export interface CreateEventErrorAction {
  errors: Error[];
  eventKey: string;
  type: EventActionType.CreateEventError;
}

export const createEventError = (
  eventKey: string,
  errors: Error | readonly Error[],
): CreateEventErrorAction => ({
  errors: castArray(errors),
  eventKey,
  type: EventActionType.CreateEventError,
});
